export const daily_overview = [
    {
        title: 'Lorem Ipsum is simply dummy text of the printing',
        subtitle: 'Lorem Ipsum has been the industry standard dummy text',
        avatar: 'business',
        id: 1
    },
    {
        title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        subtitle: 'Lorem Ipsum has been the industry standard dummy text',
        avatar: 'personal_video',
        id: 2
    },
    {
        title: 'Lorem Ipsum is simply dummy text of the printing and typesetting',
        subtitle: 'Lorem Ipsum has been the industry standard dummy text',
        avatar: 'graphic_eq',
        id: 3
    }
];